
import { Component, Prop } from "vue-property-decorator";
import { TypedVue } from "@/store/types";
import { CompetencyStatus } from "@/lib/competencies";
import { STATUS_COLORS } from "./shared";

@Component
export default class LevelDot extends TypedVue {
  @Prop({ required: true }) status!: CompetencyStatus;
  @Prop({ default: 14 }) size!: number;

  get color(): string {
    return STATUS_COLORS[this.status];
  }
}
